import React, { Component } from 'react';
import Layout from '../layout/Main';
import Sidebar from '../components/Forum/Sidebar';
import FormForum from '../components/Forum/FormForum';
import Trending from '../components/Forum/Trending';
// import Update from '../components/Forum/Update';
import {http} from '../misc/http';
import history from '../misc/history'

export default class Forum extends Component {
  state = { 
    user:{},
    isLogin: false,
    formForum: {
      category: '',
      title: '',
      content: ''
    },
    isValid: false,
    showForm: false,
    showInfo: false,
    listForum: [],
    forum:{}
  }

  componentDidMount = async () => {
    await this.getLocalData();
    await this.handleGetAll()
  }

  getLocalData = async () => {
    let user = JSON.parse(localStorage.getItem('kominfo-psre'));
    this.setState({user: user, isLogin: user !== null ? true : false})
  }

  handleSubmit = async () => {
    let {formForum} = this.state;
    formForum['author'] = `${this.state.user.name}|${this.state.user.email}`;
    let params = {
      method:'POST',
      path:'forum',
      data:formForum
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      this.handleGetAll()
      this.handleResetForm();
      // this.props.history.push('/')
      alert('Posting berhasil, kami akan segera mereview untuk publikasi');
      this.setState({showForm: false})
    }
  }

  handleResetForm = () => {
    let {formForum} = this.state;
    for (const key in formForum) {
      formForum[key] = ''
    }
    this.setState({formForum})
  }

  handleGetAll = async (category='') => {
    let params = {
      method:'GET',
      path:'forum'+category,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.code === 200) {
      let {listForum} = this.state;
      listForum = data.data;
      this.setState({listForum})
    }
  }

  handleGetById = async (id) => {
    let params = {
      method:'GET',
      path:'forum/'+id,
      showMessage: false
    }
    let {data} = await http(params);
    if (data.code === 200) {
      let {forum} = this.state;
      forum = data.data;
      this.setState({forum})
    }
  }

  handleShow = (type) => {
    let showing = {}
    if (type === 'formForum') {
      if (this.state.isLogin) {
        showing = {showForm: true}
      } else {
        history.push('/login');
        window.location.reload();
      }
    }
    else showing = {showInfo: true}
    this.setState(showing)
  }

  handleClose = (type) => {
    let showing = {}
    if (type === 'formForum') showing = {showForm: false}
    else showing = {showInfo: false}
    this.setState(showing)
  }

  handleOnChange = async ({target: {name, value}}) => {
    let {formForum} = this.state
    formForum[name] = value;
    await this.setState({formForum: formForum});
    this.handleValidate();
  }

  handleValidate = () => {
    let {isValid, formForum} = this.state;
    if (formForum.category !== '' && formForum.title !== '' && formForum.content !== '') isValid=true 
    this.setState({isValid: isValid});
  }

  handleVote = async ({refId}) => {
    if (this.state.isLogin){
      let params = {
        method:'POST',
        path:'vote',
        data:{
          refId,
          refType: 'forum'
        }
      }
      let {data} = await http(params);
      if (data.status === true && data.code === 200) {
        let listForum = this.state.listForum.map(e => {
          if (e._id === data.data.refId) e.votesData.push(data.data);
          return e
        })
        this.setState({listForum})
      }
    } else {
      history.push('/login');
      window.location.reload();
    }
  }

  render() {
    return (
      <Layout>
        <section class="forum">
          <div style={{background: '#0085C7', width:'100%', height: '250px', paddingTop: '50px'}}></div>
          <div class="container" style={{marginTop: '-190px'}}>
            <div class="row">
              <FormForum showForm={this.state.showForm} handleShow={this.handleShow} handleClose={this.handleClose} handleOnChange={this.handleOnChange} handleSubmit={this.handleSubmit} isValid={this.state.isValid}/>
              <Sidebar handleShow={this.handleShow} isLogin={this.state.isLogin} handleGetForum={this.handleGetAll}/>
              <Trending 
                listForum={this.state.listForum} 
                handleGetById={this.handleGetById} 
                isLogin={this.state.isLogin} 
                handleVote={this.handleVote}
              />
              {/* <Update/> */}
            </div>
          </div>
        </section>
      </Layout>
    )
  }
}
